import {
  Box,
  HStack,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
  Text,
} from "@chakra-ui/react";
import { ICONS } from "~/constants/icons";
// import { useUIStore } from '~/store';
import { RangePickerProps } from "./RangeFilter";

export const RangePicker = ({
  // title,
  value,
  defaultValue,
  min,
  max,
  step,
  onChange,
  onChangeEnd,
  minLabel,
  maxLabel,
}: RangePickerProps) => {
  const currentValue = value || defaultValue;

  const handleChange = (value: TODO) => {
    onChange && onChange(value);
  };

  return (
    <RangeSlider
      colorScheme="blackAlpha"
      aria-label={["minimum", "maximum"]}
      onChangeEnd={onChangeEnd}
      step={step}
      min={min}
      max={max}
      value={currentValue}
      onChange={handleChange}
      height="40px"
      mb="30px"
    >
      <RangeSliderTrack>
        <RangeSliderFilledTrack />
      </RangeSliderTrack>
      {currentValue?.map((_, index) => (
        <RangeSliderThumb
          w="8"
          h="8"
          borderWidth="1px"
          borderColor="blackAlpha.600"
          boxShadow="none"
          key={index}
          index={index}
        >
          <Box color="blackAlpha.900" w="4" h="4" as={ICONS.HOME} />
        </RangeSliderThumb>
      ))}

      {/* Labels (at each end) */}
      <HStack
        justifyContent="space-between"
        mt="6"
        py="1"
        px="0"
        mx="0"
      >
        <Text size="xs">{minLabel ?? min}</Text>
        <Text size="xs">{maxLabel ?? max}</Text>
      </HStack>
    </RangeSlider>
  );
};
